var _defs, _ellipse, _ellipse2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAloklogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 507.45 423.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #54c1e5;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n\n      .cls-3 {\n        fill: #54c1e5;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 253.72,
    cy: 211.63,
    rx: 250.72,
    ry: 208.63
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 253.72,
    cy: 211.63,
    rx: 208.12,
    ry: 206.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.17,177.02h-13.79l-21.29,69.23h11.97l5.09-18.7h21.86l5.03,18.7h12.44l-21.31-69.23ZM99.79,217.83l2.29-8.39c1.97-7.31,3.93-15.16,5.79-22.82h.4c1.78,7.66,3.88,15.51,5.87,22.82l2.25,8.39h-16.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.92 177.02 193.16 177.02 193.16 235.9 222.34 235.9 222.34 246.25 180.92 246.25 180.92 177.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.19,175.75c-15.5,0-26.29,12.81-26.29,35.57s10.79,36.2,26.29,36.2,26.3-13,26.3-36.2-10.79-35.57-26.3-35.57ZM296.19,236.81c-8.5,0-14.05-9.17-14.05-25.49s5.55-24.86,14.05-24.86,14.06,8.99,14.06,24.86-5.55,25.49-14.06,25.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "427.36 246.25 413.6 246.25 396.21 213.34 386.3 225.79 386.3 246.25 373.84 246.25 373.84 177.02 386.3 177.02 386.3 208.4 386.65 208.4 411.31 177.02 425.13 177.02 403.72 203.91 427.36 246.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAloklogo);
export default __webpack_public_path__ + "static/media/aloklogo.b1b2bf5ea460406706199ccd19d3ffd3.svg";
export { ForwardRef as ReactComponent };